//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CollaborationApplication.js";
import "../no/TransientObject.js";
import "../no/BasePart.js";
let d=[[],[[["part"],"CreateBoxShapeBuilder",{R_:{builder:"CollaborationApplication.BoxShapeBuilder"}},1,0],[["shape"],"CreateBoxShapeBuilderToEdit",{R_:{builder:"CollaborationApplication.BoxShapeBuilder"}},1,0],[["part"],"CreateNotificationZoneBuilder",{R_:{builder:"CollaborationApplication.NotificationZoneBuilder"}},1,0],[["zone"],"CreateNotificationZoneBuilderToEdit",{R_:{builder:"CollaborationApplication.NotificationZoneBuilder"}},1,0],[["zonesToDelete"],"DeleteNotificationZones",{},1,0],[["zonesToShow"],"ShowNotificationZones",{},1,0],[["zonesToHide"],"HideNotificationZones",{},1,0],[["part","numFetchedZones"],"FetchZonesFromDatabase",{R_:{fetchedZones:"CollaborationApplication.CollaborationZone[]"}},1,0],[[],"Dispose",{},0,0]],[]];
SPLM.CollaborationApplication.CollaborationZoneMgr = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CollaborationApplication.CollaborationZoneMgr";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;